import * as React from "react";
import SideMenuBar from "./SideMenuBar";
import NavBar from './NavBar';

export default function Settings() {
  return (
    <div>
        <NavBar/>
        <SideMenuBar activeClass={"settings"}/>
    </div>
  );
}
